import type { ErrorItemEntry, TimelineEntry } from '@/components/chat/types/types';
import { TIMELINE_STREAM_ERROR } from '@/utils/chatErrors';
import { generateId } from '@/utils/generateId';

/**
 * REG-51 / SWR-35: when page-load stream recovery falls back, surface a
 * QUERY_FAILED error_item and clear streaming instead of hanging silently.
 */
export const applyPageLoadQueryFailedFallback = <
  T extends { timeline: TimelineEntry[]; streamingState: unknown },
>(
  session: T
): T => {
  const timelineWithoutPlaceholder = session.timeline.filter(
    (entry) => !(entry.type === 'reasoning_item' && entry.backendIndex === -1)
  );
  const errorEntry: ErrorItemEntry = {
    type: 'error_item',
    id: generateId(),
    content: TIMELINE_STREAM_ERROR.QUERY_FAILED,
    position: timelineWithoutPlaceholder.length,
  };

  return {
    ...session,
    timeline: [...timelineWithoutPlaceholder, errorEntry],
    streamingState: null,
  };
};
